import { Injectable } from '@angular/core';
import { UtilityService } from './utility.service';
import { AngularFireDatabase, AngularFireObject, AngularFireList } from 'angularfire2/database';
import { Constants } from '../config/Constants';
import { Observable } from 'rxjs/Observable';
import { Session } from '../models/session';
import { firebase } from '@firebase/app';
import { ContentsMandatory } from '../models/contents-mandatory';
import { EventBasicInfo } from '../models/event-basic-info';


@Injectable()
export class SessionService {

  constructor(private db: AngularFireDatabase, private utilityService: UtilityService) { }

  setSessionHighlights(event_id: string, sessionHighlights) {
    return this.db.object(Constants.EVENT_URL + '/' + event_id + '/Preferences/session').update(sessionHighlights);
  }
  getSessionHighlights(event_id: string): Observable<Session> {
    if (this.utilityService.isLogged()) {
      let data: AngularFireObject<Session> = this.db.object(Constants.EVENT_URL + '/' + event_id + '/Preferences/session');
      return data.valueChanges();
    }
    return null;
  }

  getAllSession(eventId: string, ) {
    return firebase.database().ref(Constants.EVENT_URL + '/' + eventId + Constants.SESSION_URL).once("value");
  }

  getAllSessionTopics(eventId: string, ) {
    return firebase.database().ref(Constants.EVENT_URL + '/' + eventId + Constants.SESSION_TOPIC_URL).once("value");
  }

  getEventBasicInfo(eventId): Observable<EventBasicInfo> {
    if (this.utilityService.isLogged()) {
      let data: AngularFireObject<EventBasicInfo> = this.db.object(Constants.EVENT_URL + '/' + eventId + Constants.EVENT_BASIC_INFO);
      return data.valueChanges();
    }
    return null;
  }

  addBulkSession(session: any, eventID: string) {
    return this.db.object(Constants.EVENT_URL + '/' + eventID + Constants.SESSION_URL).set(session);
  }

  addBulkSessionTopics(session: any, eventID: string) {
    return this.db.object(Constants.EVENT_URL + '/' + eventID + Constants.SESSION_TOPIC_URL).set(session);
  }

  getSessionList(id: string): AngularFireList<string> {
    if (this.utilityService.isLogged()) {
      return this.db.list(Constants.EVENT_URL + '/' + id + Constants.SESSION_URL);
    }
    return null;
  }

  getSingleSessionList(eventId: string, sessionId): Observable<Session> {
    if (sessionId != null) {
      let data: AngularFireObject<Session> = this.db.object(Constants.EVENT_URL + '/' + eventId + Constants.SESSION_URL + "/" + sessionId);
      return data.valueChanges();
    }
    return null;
  }

  getSingleSessionListForTopics(eventId: string, sessionId) {
    if (sessionId != null) {
      var data =  firebase.database().ref(Constants.EVENT_URL + '/' + eventId + Constants.SESSION_URL + "/" + sessionId).once("value");
      return data;
    }
    return null;
  }

  updateSessionPosition(eventID, sessionList, sessionDeletedIdList) {
    /*if(sessionDeletedIdList != null) {
      for(let id of sessionDeletedIdList) {
        this.db.object(Constants.EVENT_URL+'/'+eventID+Constants.SESSION_URL+'/'+id).set(null);
      } for(let item of sessionList) {
        console.log(item.$key, item.position);
        let key = item.$key;
        this.db.object(Constants.EVENT_URL+'/'+eventID+Constants.SESSION_URL+"/"+key).update({position:item.position});
     }*/
    //} else {
    for (let item of sessionList) {
      console.log(item.$key, item.position, sessionList);
      let key = item.$key;
      this.db.object(Constants.EVENT_URL + '/' + eventID + Constants.SESSION_URL + "/" + key).update({ position: item.position });
    }
    //}
  }

  addSessionDetails(sessionDetails: Session, eventID: string) {
    return this.db.list(Constants.EVENT_URL + '/' + eventID + Constants.SESSION_URL).push(sessionDetails).key;
  }

  addSessionDetailsTopic(sessionDetailsTopic: any, eventID: string) {
    return this.db.list(Constants.EVENT_URL + '/' + eventID + Constants.SESSION_TOPIC_URL).push(sessionDetailsTopic).key;
  }
  updateSessionTopicDetails(sessionTopicDetails: any, eventID: string): Promise<any> {
    let sessionTopicKey = sessionTopicDetails.$key;
    delete sessionTopicDetails.$key;
    return this.db.object(Constants.EVENT_URL + '/' + eventID + Constants.SESSION_TOPIC_URL + '/' + sessionTopicKey).set(sessionTopicDetails);
  }
  updateSessionDetails(sessionDetails: Session, eventID: string, sessionId: string): Promise<any> {
    console.log(sessionDetails);
    return this.db.object(Constants.EVENT_URL + '/' + eventID + Constants.SESSION_URL + "/" + sessionId).set(sessionDetails);
  }

  deleteSessionID(event: Session, eventID: string, sessionList) {
    let abc: Array<any> = new Array();
    if (event.headerContentMandatoryList) {
      for (let key in event.headerContentMandatoryList) {
        if (event.headerContentMandatoryList.hasOwnProperty(key)) {
          abc.push(event.headerContentMandatoryList[key]);
        }
      }
      let category = 'Menu';
      for (let i = 0; i < abc.length; i++) {
        console.log(event.headerContentMandatoryList[i]);
        this.getContentsMandatoryInfo(eventID, abc[i]).subscribe(event => {
          if (event) {
            if (event.category == 'Session') {
              let storageReff = firebase.storage().ref();
              storageReff.child(`${"/" + eventID + Constants.Contents_Mandatory_URL + "/" + category}/${event.filename}`).delete();
            }
          }
        });
        this.db.list(Constants.EVENT_URL + '/' + eventID + Constants.Contents_Mandatory_URL).remove(abc[i]);
      }
    }
    if (sessionList.length == 0) {
      return this.db.list(Constants.EVENT_URL + '/' + eventID + Constants.SESSION_URL).remove(event.$key);
    } else {
      this.db.list(Constants.EVENT_URL + '/' + eventID + Constants.SESSION_URL).remove(event.$key);
      let i = 0;
      for (let item of sessionList) {
        console.log(item.$key, item.position);
        let key = item.$key;
        var data = this.db.object(Constants.EVENT_URL + '/' + eventID + Constants.SESSION_URL + "/" + key).update({ position: item.position });
        if (i == sessionList.length - 1) { return data }; i++
      }
    }
  }


  getContentsMandatoryInfo(eventId, cid): Observable<ContentsMandatory> {
    console.log('cid', cid, 'eventid', eventId)
    let data: AngularFireObject<ContentsMandatory> = this.db.object(Constants.EVENT_URL + '/' + eventId + Constants.Contents_Mandatory_URL + '/' + cid);
    return data.valueChanges();
  }
}



// WEBPACK FOOTER //
// /app/src/app/core/services/session.service.ts